export default __webpack_public_path__ + "static/hw_ff_binary-704a573ec11e46026ea082d0ee0edcb5.png";